import { boolean, object, string } from 'yup';
import { parseLithuanianPersonalCode } from '@app/lib/personal-code/parseLithuanianPersonalCode';

export const RequestHomeInsurance = object({
    personalCode: string()
        .min(1, 'profile.validation.fieldRequired')
        .required('profile.validation.fieldRequired')
        .test(
            'is-valid-personal-code',
            'eshop.home.validation.personalCodeInvalid',
            value => !!value && parseLithuanianPersonalCode(value).isValid,
        ),
    country: string().required('profile.validation.fieldRequired').min(1, 'address.validation.invalidCountry'),
    city: string().required('profile.validation.fieldRequired').min(1, 'address.validation.invalidCity'),
    municipality: string(),
    street: string().required('profile.validation.fieldRequired').min(1, 'address.validation.invalidStreet'),
    postalCode: string().required('profile.validation.fieldRequired').min(1, 'address.validation.invalidPostalCode'),
    houseNumber: string().required('profile.validation.fieldRequired').min(1, 'address.validation.invalidHouseNumber'),
    apartmentNumber: string(),
    isPropertyEligibleForInsurance: boolean()
        .is([true], 'eshop.home.validation.propertyEligibilityRequired')
        .required('profile.validation.fieldRequired'),
    canReceiveInformationFromRegisterCenter: boolean().required('profile.validation.fieldRequired'),
    acceptPrivacyPolicy: boolean()
        .is([true], 'eshop.home.validation.mustAcceptPrivacyPolicyLanding')
        .required('profile.validation.fieldRequired'),
});
